import { call, put, takeLatest } from "redux-saga/effects";
import { userServiceV2 } from "../services/userServiceV2";
import { LOGOUT_FAILURE, LOGOUT_SUCCESS, LOGOUT_USER } from "../actions/actionTypes";

function * logoutUser(action: any) {
    try {
        const res = yield call(userServiceV2.logout);
        if(res.statusCode === 200) {
            yield put({type: LOGOUT_SUCCESS, data: {isAuthenticated: false,authenticatedUser: null,selectedRoleIndex: 0,selectedRole: false, unregisteredDevicesData: null}});
            window.location.pathname = '/login';
        } else {
            yield put({type: LOGOUT_FAILURE, data: {}});
        }
    } catch (err) {
        yield put({type: LOGOUT_FAILURE, data: {}});
    }
}

function * authSaga() {
    yield takeLatest(LOGOUT_USER, logoutUser);
}

export default authSaga;